export const formatCurrency = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "$0.00";
  const num = typeof value === "string" ? parseFloat(value) : Number(value);
  if (Number.isNaN(num)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(num);
};

export const parsePrice = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;
  const parsed = typeof value === "string" ? parseFloat(value) : Number(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const parseListString = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value as string[];
  if (typeof value !== "string") return [];

  const trimmed = value.trim();
  if (!trimmed) return [];

  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) return parsed;
  } catch {
    // fall through
  }

  if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
    try {
      const parsed = JSON.parse(trimmed.replace(/'/g, '"'));
      if (Array.isArray(parsed)) return parsed;
    } catch {
      const inner = trimmed.slice(1, -1).trim();
      if (inner) {
        const items = inner
          .split(",")
          .map((item) => stripQuotes(item.trim()))
          .filter(Boolean);
        if (items.length > 0) return items;
      }
    }
  }

  return trimmed
    .split(",")
    .map((item) => stripQuotes(item.trim()))
    .filter(Boolean);
};

const stripQuotes = (s: string): string => {
  if (
    (s.startsWith("'") && s.endsWith("'")) ||
    (s.startsWith('"') && s.endsWith('"'))
  ) {
    return s.slice(1, -1).trim();
  }
  return s;
};
